export default __webpack_public_path__ + "pdf/college_map.958f0cf.pdf";